export default [
  {
    label: `Choosing my intended major`,
    value: `intended_major`,
  },
  {
    label: `Planning my summer/extracurricular activities`,
    value: `summer_activity`,
  },
  {
    label: `Studying for the SAT or ACT`,
    value: `studyfor_act_sat`,
  },
  {
    label: `Taking the SAT or ACT`,
    value: `taking_act_sat`,
  },
  {
    label: `Researching colleges`,
    value: `research_college`,
  },
  {
    label: `Building my college list`,
    value: `build_collegelist`,
  },
  {
    label: `Categorizing the schools on my list as Reach, Target, and Safety`,
    value: `categorization`,
  },
  {
    label: `Creating an application strategy (i.e. deciding where to apply Early Action or Early Decision)`,
    value: `application_strategy`,
  },
  {
    label: `Creating a Common Application account`,
    value: `commonapp_account`,
  },
  {
    label: `Brainstorming personal statement topics`,
    value: `personal_statement_topics`,
  },
  {
    label: `Writing my personal statement`,
    value: `personal_statement_writing`,
  },
  {
    label: `Brainstorming supplemental essay topics`,
    value: `supplemental_essay_topics`,
  },
  {
    label: `Writing supplemental essays`,
    value: `supplemental_essay_writing`,
  },
  {
    label: `Exploring financial aid options`,
    value: `financial_aid`,
  },
];
